// @flow
// import * as React from 'react';
import { branch } from 'recompose';
import styled, { css } from 'styled-components';

export const StyledCircle = styled.div`
  border-radius: 50%;
  position: relative;
  height: ${({ radius = 39 }) => `${radius}px`};
  width: ${({ radius = 39 }) => `${radius}px`};
`;

export const CircleOutline = styled(StyledCircle)`
  background: var(--color-white);

  ${({ outlineStyle }) =>
    css`
      ${outlineStyle};
    `};
`;

export const CircleFilled = styled(StyledCircle)`
  ${({ filledStyle }) =>
    css`
      ${filledStyle};
    `};
`;

export const Circle = branch(
  ({ outline = false }) => outline === true,
  () => CircleOutline,
)(CircleFilled);
